import { render } from "./LikeButton.vue?vue&type=template&id=3ca2d425"
import script from "./LikeButton.vue?vue&type=script&lang=js"
export * from "./LikeButton.vue?vue&type=script&lang=js"

import "./LikeButton.vue?vue&type=style&index=0&id=3ca2d425&lang=scss"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__